/* eslint-disable no-param-reassign */
import create from 'zustand';
import { DreamWithOverride } from '../../plate';
import { StorePluginOptions } from './types';

export const withStore: DreamWithOverride<StorePluginOptions> = (
  editor,
  plugin,
) => {
  const { onChange } = editor;
  const { createInitialState } = plugin.options;

  const store = create(createInitialState);

  store.setState({ editor });

  editor.store = store;

  editor.onChange = () => {
    onChange();
    store.setState({ editor });
  };

  return editor;
};
